__turbopack_context__.v({
  "action-wrap": "qHDbxW_action-wrap",
  "active": "qHDbxW_active",
  "collapse-container": "qHDbxW_collapse-container",
  "head-title": "qHDbxW_head-title",
  "page-body-wrap": "qHDbxW_page-body-wrap",
  "page-content-head": "qHDbxW_page-content-head",
  "page-search-content": "qHDbxW_page-search-content",
  "responsive-mobile": "qHDbxW_responsive-mobile",
  "search-input": "qHDbxW_search-input",
  "search-list": "qHDbxW_search-list",
  "search-list-row": "qHDbxW_search-list-row",
  "tab-container": "qHDbxW_tab-container",
  "tag": "qHDbxW_tag",
  "text": "qHDbxW_text",
  "topic-logo-wrap": "qHDbxW_topic-logo-wrap",
});
